import React, { useState, useEffect } from "react"


const useUnsavedChangesWarning = (initialValue) => {
    const [isEdited, setEdit] = useState(initialValue)

    const message = "Leave site? \nChanges that you made may not be saved."

    useEffect(() => {
        window.onbeforeunload = isEdited && (() => message)

        return () => {
            window.onbeforeunload = null
        }
    }, [isEdited])

    return [() => setEdit(true), () => setEdit(false)]
}

export default useUnsavedChangesWarning